// extracted by mini-css-extract-plugin
module.exports = {"labelAvatar":"ModalRegistration_labelAvatar__31JgZ","inputAvatar":"ModalRegistration_inputAvatar__3YCgE"};